import { ProjectTaskModel } from '../../core/models/project/project-task.model';
import { ClockStatus, TimerStatus } from '../../features/calendar/calendar-types';
import { ITimeBlockComponentItem } from '../../features/calendar/components/time-block/types/time-block-component-item-types';

export type TimeBlockWithTask = {
  timeBlock: ITimeBlockComponentItem;
  task: ProjectTaskModel;
};

export type ClockData = [number, ClockStatus];

export enum TimeBlockSource {
  TimerSource = 'webapp_timer',
  TrackerSource = 'tracker',
}

export type TimerResponse = {
  status: TimerStatus;
  generatedTimeBlock: ITimeBlockComponentItem;
};
